import keys from 'lodash/keys';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

//import get from 'lodash/get';
import cn from 'classnames';
import css from './css.css';
import noop from 'lodash/noop';

import { Box, Button, HStack, List, Text, VStack, } from "~/native-ui"

let propTypes = {
    children: PropTypes.node,
	onExpand: PropTypes.func,
    mode: PropTypes.string.isRequired,
	isExpanded: PropTypes.bool,
	expandButtonProps: PropTypes.shape(),
};

let ownPropNames = keys(propTypes);

export default class CollapseList extends Component {
	static propTypes = propTypes;

	static defaultProps = {
		onExpand: noop,
        mode: 'unordered'
	};

	state = {
		expanded: false
	};

    expand = (e, val = true) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({expanded: val});
		
		this.props.onExpand(val);
        return false;
    };

    ownProps = () => {
    	return omit(this.props,ownPropNames);
	};

	buttonTextStyle = {fontSize: "sm", }
    renderExpandButton = (childArr, val = true, sign = '+') => {
        let moreCount = childArr.length-1;

        return <Button key="expand-button" alignSelf="flex-start" colorScheme="primary" ghost ml="2" p="2px" px="1" flexGrow="0" flexShrink="0" _text={this.buttonTextStyle} { ...this.props.expandButtonProps } onClick={(e) => this.expand(e, val)} label={sign + moreCount} { ...this.props.expandButtonProps } />
	};

	renderFirstChildOnly = () => {
		const child = React.Children.toArray(this.props.children)[0];
		if (!child) return null;

		return React.cloneElement(child, {
			...child?.props,
			unstyled: true,
		})
	}

	renderExpand = (childArr) => {
		return (
				<Box ml="-8px" maxWidth="100%" flexDirection="row" {...this.ownProps()} flex="1" className={cn(css.liUnstyler, this.props.className)}>
					<VStack key="list" alignSelf="center" flex="1">{this.renderFirstChildOnly()}</VStack>
					{this.renderExpandButton(childArr)}
				</Box>
		)
	};


	renderList = (childArr) => {
		let { mode } = this.props;

		const renderEntry = (e) => {
			return e;
		};

		let list = null;

		switch(mode) {
			case 'delimiter':
                list = childArr.map((curr, i) => {
                	let delimiter = (i+1) === childArr.length ? '' : ', ';
                	return <HStack key={`delimiter-${i}`} className={css.liUnstyler}>{curr}<Text>{delimiter}</Text></HStack>;
				});
				list = <Box ml="-8px" maxWidth="100%">{list}</Box>;
                break;
			case 'ordered':
				list = (
					<List.Ordered key="ordered-list" ml="-8px" space={2} ordered {...this.ownProps() } className={cn(this.props.className, css.list)}>
						{childArr}
					</List.Ordered>
				);
				break;
			default:
				list = (
					<List.Unordered key="unordered-list" ml="-8px" space={2} {...this.ownProps()} className={cn(this.props.className, css.list)}>
						{childArr}
					</List.Unordered>
				);
				break;
		}

        return list;
	};

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.children !== this.props.children) {
            this.setState({ expanded: false });
        }
    };

	render() {
		let isExpanded = this.state.expanded || this.props.isExpanded,
			childArr = React.Children.toArray(this.props.children);

		if(!childArr.length) { return null; }

		if(isExpanded) {
			return this.renderList(childArr);
		}

		if(childArr.length > 1) {
			return this.renderExpand(childArr);
		}

		return <Box ml="-8px" maxWidth="100%" {...this.ownProps()} className={cn(css.liUnstyler, this.props.className)}>{this.renderFirstChildOnly()}</Box>;
	}
}